/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import FormField from "../FormField";
import { DateTimePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import MDEditorField from "../../../new-event/components/MDEditorField";

// NewProduct page components

function EventInfo({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { name, start_date, end_date, description, will_process } = formField;
  const {
    name: nameV,
    start_date: startDateV,
    end_date: endDateV,
    description: descriptionV,
    will_process: willProcessV
  } = values;

  const AIChoice = [
    {
      value: true,
      label: "AI On"
    },
    {
      value: false,
      label: "AI Off"
    }
  ];
  const aiChoiceHandler = (e, newValue) => {
    setFieldValue("will_process", newValue.value);
  };
  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5">Event Information</MDTypography>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <MDBox mb={3}>
                <MDBox mb={0} display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Name
                  </MDTypography>
                </MDBox>
                <FormField type={name.type}
                           name={name.name}
                           value={nameV}
                           placeholder={name.placeholder}
                           error={errors.name && touched.name}
                           success={nameV.length > 0 && !errors.name} />
              </MDBox>
            </Grid>
            <Grid item xs={12} sm={6}>
              <MDBox mb={3}>
                <MDBox display="inline-block">
                  <MDTypography
                    component="label"
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    textTransform="capitalize"
                  >
                    Artificial Intelligence Support
                  </MDTypography>
                </MDBox>
                <Autocomplete
                  value={AIChoice.find(e => e.value === willProcessV)}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  getOptionLabel={(g) => g.label}
                  options={AIChoice}
                  onChange={aiChoiceHandler}
                  renderInput={(params) => <MDInput {...params} variant="standard" />}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <DateTimePicker
                label="Start Date"
                ampm={false}
                value={startDateV}
                onChange={(newValue) => {
                  setFieldValue("start_date", newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
                  <DateTimePicker
                  label="End Date"
                  ampm={false}
                  value={endDateV}
                  onChange={(newValue) => {
                  setFieldValue("end_date", newValue);
                }}
                  renderInput={(params) => <TextField {...params} />}
                  />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                  Description&nbsp;&nbsp;
                </MDTypography>
              </MDBox>
              <MDEditorField label={description.label}
                             name={description.name}
                             value={descriptionV} />
            </Grid>

          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default EventInfo;
